import React from "react";
import Tooltip from "@mui/material/Tooltip";

import { formatTripDate } from "../../../helpers/dates";

const getPrimaryItinerary = (itineraryData = []) => {
  if (!itineraryData.length) return null;
  const sorted = [...itineraryData].sort(
    (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0),
  );
  return sorted[0] || itineraryData[itineraryData.length - 1];
};

const formatDate = (date) => (date ? formatTripDate(date, "M/D/YYYY") : "N/A");

const formatRouting = (leg) => {
  const dep = leg?.departureAirport?.code || "—";
  const arr = leg?.arrivalAirport?.code || "—";
  return `${dep} - ${arr}`;
};

const TruncCell = ({ value }) => {
  const text = value || "N/A";
  return (
    <Tooltip title={text} arrow>
      <span className="tv-truncate tv-cell">{text}</span>
    </Tooltip>
  );
};

const ItineraryConfirmationBlock = ({ tripId, trip, readOnly }) => {
  const itinerary = getPrimaryItinerary(trip?.itineraryData);
  const legs = itinerary?.legs || [];

  const openInNewTab = (path) =>
    window.open(path, "_blank", "noopener,noreferrer");

  return (
    <div className="tv-block tv-itinerary">
      <div className="tv-block-header">
        <h5 className="tv-block-title">Itinerary Confirmation</h5>
        {legs.length > 0 && (
          <div className="tv-block-actions">
            <button
              type="button"
              className="base-button icon-button icon-button-small evo-blue"
              onClick={() =>
                openInNewTab(
                  `/trips/${tripId}/itineraries/${itinerary._id}/preview`,
                )
              }
              title="Preview Itinerary"
            >
              <span className="material-icons">visibility</span>
            </button>
            {!readOnly && (
              <button
                type="button"
                className="base-button icon-button icon-button-small evo-blue"
                onClick={() =>
                  openInNewTab(`/trips/${tripId}/itineraries/${itinerary._id}`)
                }
                title="Edit Itinerary"
              >
                <span className="material-icons">edit</span>
              </button>
            )}
          </div>
        )}
      </div>

      <div className="tv-block-body">
        {legs.length === 0 ? (
          <div className="tv-empty">No itinerary data available.</div>
        ) : (
          <table className="tv-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Routing</th>
                <th>Aircraft</th>
                <th>Tail #</th>
                <th>Operator</th>
              </tr>
            </thead>
            <tbody>
              {legs.map((leg, i) => (
                <tr key={leg._id || i}>
                  <td>{formatDate(leg.departureDate)}</td>
                  <td>{formatRouting(leg)}</td>
                  <td>
                    <TruncCell value={leg.aircraft?.name}/>
                  </td>
                  <td>
                    <TruncCell value={leg.tailNumber}/>
                  </td>
                  <td>
                    <TruncCell value={leg.operator?.name}/>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ItineraryConfirmationBlock;
